import React from 'react';
import styled from 'styled-components';
import * as colors from '../../util/colors';
import { Heading } from '../../util/typography';
import { createLocalScaleFunction } from '../../util/functions';
import headerBack from '../../assets/header-back.png';
import qlexTrilogy from '../../assets/QLEX-trilogy-header.svg';
import qlexTrilogyMob from '../../assets/QLEX-trilogy-mob.svg';
import ivTrilogyDesk from '../../assets/IV-trilogy-desktop.svg';
import ivTrilogyMob from '../../assets/IV-trilogy-mobile.svg';
import { NAVIGATION_BREAKPOINT } from '../../constants/layout';

export const HeaderContainer = styled.div`
    background: linear-gradient(120deg, ${colors.keytrudaGreenWeb}, ${colors.consumerGreen});
`;
export const Header = styled.div`
    background-image: url(${headerBack});
    background-repeat: no-repeat;
    background-position: center;
    background-size: 100% auto;
    max-width: 1032px;
    padding: 0 20px;
    margin: auto;
`;
export const HeaderText = styled(Heading.H1)`
    color: white;
    padding: ${createLocalScaleFunction(20, 320, 40, 992)} 0;
`;
// Branding bars
const BrandingBars = styled.div`
  width: 100%;
`;

const BrandingBar = styled.div`
  width: 100%;
  height: 4px;
  background-color: ${({ color }) => color};
`;

//batch 2.0
const Wrapper = styled.div`
display: flex;
justify-content: center;
border-bottom: 1px solid ${colors.mist};
background: ${colors.greenWhiteGradient};

@media(min-width: 1033px){
background: linear-gradient(90deg, #F0FAED 0%, #F0FAED calc((100vw - 1032px) / 2 + 932.72px), #FFF calc((100vw - 1032px) / 2 + 977.82px));
}

//mobile
@media(max-width: 765px){
}
`;

const PageHeaderContainer = styled.div`
max-width: 1032px;
width: 100%;
padding: 40px 20px;
padding-right: 75px;
display: flex;
flex-direction: column;
gap:10px; 

background-image: ${({trilogyImg}) => `url(${trilogyImg.desktop})`};
background-repeat: no-repeat;
background-position: bottom right;
background-size: contain;

@media(max-width: ${NAVIGATION_BREAKPOINT}){
background-image: ${({trilogyImg}) => `url(${trilogyImg.mobile})`};
${({subtitle}) => !subtitle && `
    background-position: top right;
    background-size: 25%;
`}
padding: 20px 20px;
padding-right: 80px;
}
`;

const PageHeaderText = styled(Heading.H1)`
max-width: 852px;`;

const PageSubheaderText= styled(Heading.H4)`
padding: 4px 10px;
color: ${colors.keytrudaGreenWeb};
width: fit-content;

border: 1px solid #ADDC9A;
border-radius: 4px;
@media(max-width: ${NAVIGATION_BREAKPOINT}){
    max-width: 80%;
}
`;

const mapTrilogyImg = brand => {
    if (!brand) 
        return {
                mobile: ivTrilogyMob,
                desktop: ivTrilogyDesk
            };

    switch(brand) {
        case 'keytrudaIV':
            return {
                mobile: ivTrilogyMob,
                desktop: ivTrilogyDesk
            };
        case 'qlex' :
            return {
                mobile: qlexTrilogyMob,
                desktop: qlexTrilogy
            };
        default: return null;
    }
}

const PageHeader = props => {
    const trilogyImg = mapTrilogyImg(props.brand);
    return (<>
        {props.batch2 ? 
        <Wrapper>
            <PageHeaderContainer trilogyImg={trilogyImg} subtitle={props.subtitle}>
                <PageHeaderText>{props.title}</PageHeaderText>
              { props.subtitle && <PageSubheaderText>{props.subtitle}</PageSubheaderText>}
            </PageHeaderContainer>
        </Wrapper>
            :
        <HeaderContainer>
            <Header>
                <HeaderText as='H1'>{props.title}</HeaderText>
            </Header>
            {props.isBranding && (
                <BrandingBars>
                    <BrandingBar color="#ADDC9A" />
                    <BrandingBar color={colors.keytrudaGreen} />
                    <BrandingBar color={colors.lightPurple} />
                </BrandingBars>
            )}
        </HeaderContainer>}
   </> );
};

export default PageHeader;